// Customizable Area Start
import { IBlock } from "../../../framework/src/IBlock";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import React from "react";
import moment from "moment";
import { Swiper } from "swiper/types";
import { SwiperRef } from "swiper/react";
import {
  IncomingMessage,
  BaseEntities,
  AttachmentInfo,
  User,
  CometCall
} from "./ChatController";
import { CallTypes } from "../../../components/src/CustomCallBubble.web";
export const configJSON = require("./config");
// Customizable Area End


// Customizable Area Start
export const THUMB_SWIPER_BREAKPOINTS = {
  0: {
    slidesPerView: 3,
  },
  640: {
    slidesPerView: 4,
  },
  768: {
    slidesPerView: 5,
  },
};

export interface AttachmentMeta {
  name: string;
  url: string;
  mimeType: string;
  type: string
  extension: string
}

export interface CometChatUser {
  uid: string;
  name: string;
  avatar?: string;
}

export type MessageType = "text" | "media" | "custom";

export interface ParsedChatMessage {
  id: string;
  type: MessageType;
  conversationId: string;
  sentAt: number;
  sender: User;
  text: string | null;
  readAt?: number
  attachments: AttachmentMeta[];
  raw: IncomingMessage;
}
// Customizable Area End

export interface Props {
  // Customizable Area Start
  navigation: any;
  chatDetails: IncomingMessage;
  loggedInUserId: string;
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  currentImageIndex: number;
  isImagePreviewOpen: boolean;
  thumbsSwiper: Swiper | null;
  // Customizable Area End
}

interface SS {
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

export default class ChatRenderController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  swiperRef: React.RefObject<SwiperRef> = React.createRef();
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      // Customizable Area End
    ];

    this.state = {
      // Customizable Area Start
      currentImageIndex: 0,
      isImagePreviewOpen: false,
      thumbsSwiper: null,
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  async componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape" && this.state.isImagePreviewOpen) {
      this.closeImagePreview();
    }
  };

  getCallLogIcon = (callInfo: CometCall, isOwnMsg: boolean): CallTypes => {
    return (isOwnMsg ? `out_${callInfo.type}` : `in_${callInfo.type}`) as CallTypes;
  }

  parseMessage = (message: IncomingMessage): ParsedChatMessage => {
    const {
      id,
      sentAt,
      conversationId,
      category,
      type,
      data,
      readAt,
      sender
    } = message;

    let text: string | null = null;
    let attachments: AttachmentMeta[] = [];
    let parsedType: MessageType = "text";

    if (category === "message" && type === "text") {
      text = (data as { text: string; entities: BaseEntities }).text;
    } else if (category === "message") {
      parsedType = "media";
      attachments =
        (data as { attachments: AttachmentInfo[] }).attachments.map(
          (att: AttachmentInfo) => ({
            name: att.name,
            url: att.url,
            mimeType: att.mimeType,
            type,
            extension: att.extension
          })
        ) || [];
    }

    return {
      id,
      type: parsedType,
      conversationId,
      sentAt,
      sender: sender,
      text,
      attachments,
      raw: message,
      readAt 
    };
  };

  openImagePreview = (currentIndex: number) => {
    this.setState({
      currentImageIndex: currentIndex,
      isImagePreviewOpen: true,
    });
  };

  closeImagePreview = () => {
    this.setState({ isImagePreviewOpen: false, thumbsSwiper: null });
  };

  handleSlideChange = (currentIndex: number) => {
    this.setState({ currentImageIndex: currentIndex });
  };

  handleOnSwiperChange = (swiper: Swiper) => {
    this.setState({ thumbsSwiper: swiper });
  };

  goToNextSlide = () => {
    if (this.swiperRef.current?.swiper) {
      this.swiperRef.current.swiper.slideNext();
    }
  };

  goToPrevSlide = () => {
    if (this.swiperRef.current?.swiper) {
      this.swiperRef.current.swiper.slidePrev();
    }
  };

  getLocalDate = (timestamp: number): string => {
    return moment
      .unix(timestamp)
      .local()
      .format("DD/MM/YYYY");
  };

  getLocalTime = (timestamp: number) => {
    return moment
      .unix(timestamp)
      .local()
      .format("hh:mm A");
  };
  // Customizable Area End
}
